import { BaseError } from '../errors/base';
import { BaseErrorCodes } from '../errors/codes';

/**
 * Custom error type for music theory operations
 */
export class TheoryServiceError extends BaseError {
  constructor(message: string, detailCode: string = 'THEORY_SERVICE_ERROR', details?: unknown) {
    super(message, BaseErrorCodes.Core, detailCode, details);
  }
}
